// extracted by mini-css-extract-plugin
export default {"navList":"SimpleNavBar_navList__YVdwF","navItem":"SimpleNavBar_navItem__5nuz2","navLink":"SimpleNavBar_navLink__6SGuN"};